import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import * as styleguide from "@store/theme/styleguide";

const _styleguide = styleguide as any;

setPostStyleGuideTheme(_styleguide); // Change to 'setPreStyleGuideTheme' as needed
